import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// ── Customers ──
export async function getCustomers() { return (await axios.get(`${API}/customers`)).data; }
export async function addCustomer(customer) { return (await axios.post(`${API}/customers`, customer)).data; }
export async function addCustomersBulk(customers) { return (await axios.post(`${API}/customers/bulk`, customers)).data; }
export async function getCustomerById(id) { try { return (await axios.get(`${API}/customers/${id}`)).data; } catch { return null; } }
export async function updateCustomer(id, updates) { return (await axios.put(`${API}/customers/${id}`, updates)).data; }
export async function deleteCustomer(id) { await axios.delete(`${API}/customers/${id}`); }
export async function deleteCustomersBulk(ids) { await axios.post(`${API}/customers/bulk-delete`, { ids }); }

// ── Bills ──
export async function getBills(customerId = null) { return (await axios.get(`${API}/bills`, { params: customerId ? { customerId } : {} })).data; }
export async function addBill(bill) { return (await axios.post(`${API}/bills`, bill)).data; }
export async function addBillsBulk(bills) { return (await axios.post(`${API}/bills/bulk`, bills)).data; }
export async function getBillById(id) { try { return (await axios.get(`${API}/bills/${id}`)).data; } catch { return null; } }
export async function getBillsByCustomer(customerId) { return getBills(customerId); }
export async function markBillPaid(id, paymentDetails = {}) { return (await axios.put(`${API}/bills/${id}/pay`, paymentDetails)).data; }
export async function bulkMarkPaid(ids, paymentDate, paymentMode = "Cash") { return (await axios.post(`${API}/bills/bulk-pay`, { ids, paymentDate, paymentMode })).data; }
export async function editBill(id, updates) { return (await axios.put(`${API}/bills/${id}`, updates)).data; }
export async function editPayment(billId, paymentIdx, updates) { return (await axios.put(`${API}/bills/${billId}/payments/${paymentIdx}`, updates)).data; }
export async function deletePayment(billId, paymentIdx) { return (await axios.delete(`${API}/bills/${billId}/payments/${paymentIdx}`)).data; }

// ── Settings ──
export async function getSettings() { return (await axios.get(`${API}/settings`)).data; }
export async function saveSettings(settings) { return (await axios.put(`${API}/settings`, settings)).data; }

// ── Utility ──
export async function getLastReading(customerId) { return (await axios.get(`${API}/last-reading/${customerId}`)).data.lastReading; }

// ── Backup ──
export async function exportBackup() { return (await axios.get(`${API}/backup`)).data; }
export async function importBackup(backupData) { return (await axios.post(`${API}/restore`, backupData)).data; }

// ── User Management ──
export async function getUsers() { return (await axios.get(`${API}/users`)).data; }
export async function createUser(userData) { return (await axios.post(`${API}/users`, userData)).data; }
export async function updateUser(uid, updates) { return (await axios.put(`${API}/users/${uid}`, updates)).data; }
export async function resetUserPassword(uid, password) { return (await axios.post(`${API}/users/${uid}/reset-password`, { password })).data; }
export async function changePassword(currentPassword, newPassword) { return (await axios.post(`${API}/auth/change-password`, { currentPassword, newPassword })).data; }
export async function updateProfile(updates) { return (await axios.put(`${API}/auth/profile`, updates)).data; }

// ── Customer Balance ──
export async function getCustomerBalance(cid) { return (await axios.get(`${API}/customers/${cid}/balance`)).data; }

// ── Audit Log ──
export async function getAuditLogs(params = {}) { return (await axios.get(`${API}/audit-logs`, { params })).data; }

// ── Rate Management ──
export async function changeRate(rateData) { return (await axios.post(`${API}/rates/change`, rateData)).data; }
export async function getRateHistory() { return (await axios.get(`${API}/rates/history`)).data; }

// ── Statements ──
export async function getCustomerStatement(cid, dateFrom, dateTo) { return (await axios.get(`${API}/statements/customer/${cid}`, { params: { dateFrom, dateTo } })).data; }
export async function getSocietyStatement(society, dateFrom, dateTo) { return (await axios.get(`${API}/statements/society/${encodeURIComponent(society)}`, { params: { dateFrom, dateTo } })).data; }

// ── Excel Export ──
export async function exportExcel() {
  const response = await axios.get(`${API}/export/excel`, { responseType: 'blob' });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.download = 'superflame_export.xlsx';
  link.click();
  window.URL.revokeObjectURL(url);
}
